/* eslint-disable react-refresh/only-export-components */
import { useMemo } from "react";

import TilleyDataGrid from "components/shared/DataGrid/TilleyDataGrid";

const getFarmRowSummary = (value, row) => {
  const nameLabel = row?.business_name ? row.business_name : row.last_name;
  const commodityLabel = `${row?.commodity_name} ${row?.practice_name}`;
  return String(
    `${nameLabel} ${row.location_county_name} / ${row.fsa_farm_number} T${row.fsa_tract_number} (${row.fsa_field_number}) / ${row.basic_unit_number}-${row.optional_unit_number} / ${commodityLabel}`
  );
};

export const COLUMNS_PRODUCERFARMCROPWITHHISTORY = [
  {
    field: "yield_commodity_year",
    headerName: "Year",
    flex: 1,
  },
  {
    field: "fsa_farm_number",
    headerName: "FSN",
    flex: 1,
  },
  {
    field: "fsa_tract_number",
    headerName: "Tract",
    flex: 1,
  },
  {
    field: "fsa_field_number",
    headerName: "Field",
    flex: 1,
  },
  // {
  //     field: 'location_county_name',
  //     headerName: 'County',
  //     valueGetter: getStateCountySummary,
  //     flex: 1
  // },
  {
    field: "commodity_name",
    headerName: "Commodity",
    flex: 1,
  },
  {
    field: "practice_name",
    headerName: "Practice",
    flex: 1,
  },
  // {
  //   field: "approved_yield",
  //   headerName: "APH",
  //   flex: 1,
  // },
  {
    field: "annual_yield",
    headerName: "Yield",
    flex: 1,
  },
  {
    field: "yield_acreage",
    headerName: "Yield Acres",
    flex: 1,
  },
];

export const COLUMNS_PRODUCERFARMCROPWITHHISTORY_SMALL = [
  {
    field: "fsa_farm_number",
    headerName: "Unit",
    valueGetter: getFarmRowSummary,
    flex: 1,
  },
];

export default function ProducerFarmCropWithHistoryDataGrid({ producerFarmCropWithHistory }) {
  const memoizedColumns = useMemo(() => COLUMNS_PRODUCERFARMCROPWITHHISTORY, []);

  return (
    <>
      <TilleyDataGrid
        rows={producerFarmCropWithHistory || []}
        columns={memoizedColumns}
        pageSizeOptions={[5, 10, 25]}
        defaultPageSize={5}
        gridKey="producer-farm-crop-with-history"
        getRowId={(row) => row.id}
      />
    </>
  );
}
